export default __webpack_public_path__ + "37b1320f3ce0a814b78d1d307ca51233.svg";